// src/helpers/factories/settings/kitchenTicketFactory.ts
var HEADER_BLANK_SPACE_OPTIONS = [
  "0" /* ZERO */,
  "0.25" /* ZERO_TWO_FIVE */,
  "0.5" /* ZERO_FIVE */,
  "0.75" /* ZERO_SEVEN_FIVE */,
  "1.00" /* ONE */,
  "1.25" /* ONE_TWO_FIVE */,
  "1.5" /* ONE_FIVE */,
  "1.75" /* ONE_SEVEN_FIVE */,
  "2.0" /* TWO */
];
var ELEMENT_SPACING_OPTIONS = [
  "0" /* ZERO */,
  "0.02" /* ZERO_ZERO_TWO */,
  "0.05" /* ZERO_ZERO_FIVE */,
  "0.1" /* ZERO_ONE */,
  "0.15" /* ZERO_ONE_FIVE */,
  "0.2" /* ZERO_TWO */,
  "0.25" /* ZERO_TWO_FIVE */
];
var KITCHEN_PRINTER_COLOR_OPTIONS = [
  "black" /* BLACK */,
  "negative" /* NEGATIVE */
];
var KITCHEN_TICKET_JUSTIFY_OPTIONS = [
  "left" /* LEFT */,
  "center" /* CENTER */,
  "right" /* RIGHT */
];
var KITCHEN_TICKET_FONT_SIZE_OPTIONS = [
  "a11" /* A11 */,
  "b11" /* B11 */,
  "a12" /* A12 */,
  "b12" /* B12 */,
  "a21" /* A21 */,
  "b21" /* B21 */,
  "a22" /* A22 */,
  "b22" /* B22 */
];
var KITCHEN_TICKET_FONT_WEIGHT_OPTIONS = [
  "normal" /* NORMAL */,
  "bold" /* BOLD */
];
var KITCHEN_TICKET_LINE_OPTIONS = [
  "none" /* NONE */,
  "below" /* BELOW */,
  "above" /* ABOVE */
];
var KITCHEN_TICKET_TEXT_POSITION_OPTIONS = ["Before" /* BEFORE */, "After" /* AFTER */];
var textPositionOptionsFactory = (t) => [
  {
    label: t("commonTexts.before"),
    value: KITCHEN_TICKET_TEXT_POSITION_OPTIONS.indexOf(
      "Before" /* BEFORE */
    ) + 1
  },
  {
    label: t("commonTexts.after"),
    value: KITCHEN_TICKET_TEXT_POSITION_OPTIONS.indexOf(
      "After" /* AFTER */
    ) + 1
  }
];
var headerBlankSpaceOptionsFactory = (t) => [
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.zero"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf("0" /* ZERO */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.zeroTwoFive"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf(
      "0.25" /* ZERO_TWO_FIVE */
    ) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.zeroFive"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf("0.5" /* ZERO_FIVE */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.zeroSevenFive"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf(
      "0.75" /* ZERO_SEVEN_FIVE */
    ) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.one"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf("1.00" /* ONE */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.oneTwoFive"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf("1.25" /* ONE_TWO_FIVE */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.oneFive"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf("1.5" /* ONE_FIVE */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.oneSevenFive"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf(
      "1.75" /* ONE_SEVEN_FIVE */
    ) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.ticketDisplay.headerBlankSpace.options.two"
    ),
    value: HEADER_BLANK_SPACE_OPTIONS.indexOf("2.0" /* TWO */) + 1
  }
];
var elementSpacingOptionsFactory = () => ELEMENT_SPACING_OPTIONS.map((option, index) => ({
  label: `${option}"`,
  value: index + 1
}));
var kitchenPrinterColorOptionsFactory = (t) => [
  {
    label: t("settingsModule.kitchenTicketSettings.printerColors.black"),
    value: KITCHEN_PRINTER_COLOR_OPTIONS.indexOf("black" /* BLACK */) + 1
  },
  {
    label: t("settingsModule.kitchenTicketSettings.printerColors.negative"),
    value: KITCHEN_PRINTER_COLOR_OPTIONS.indexOf("negative" /* NEGATIVE */) + 1
  }
];
var kitchenTicketJustifyOptionsFactory = (t) => [
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.justify.options.left"
    ),
    value: KITCHEN_TICKET_JUSTIFY_OPTIONS.indexOf("left" /* LEFT */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.justify.options.center"
    ),
    value: KITCHEN_TICKET_JUSTIFY_OPTIONS.indexOf("center" /* CENTER */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.justify.options.right"
    ),
    value: KITCHEN_TICKET_JUSTIFY_OPTIONS.indexOf("right" /* RIGHT */) + 1
  }
];
var kitchenTicketFontSizeOptionsFactory = (t) => [
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.b11"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf("b11" /* B11 */) + 1,
    font: "b11" /* B11 */
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.a11"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf(
      "a11" /* A11 */
    ) + 1,
    font: "a11" /* A11 */
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.b12"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf("b12" /* B12 */) + 1,
    font: "b12" /* B12 */
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.a12"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf(
      "a12" /* A12 */
    ) + 1,
    font: "a12" /* A12 */
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.b21"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf("b21" /* B21 */) + 1,
    font: "b21" /* B21 */
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.a21"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf(
      "a21" /* A21 */
    ) + 1,
    font: "a21" /* A21 */
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.b22"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf(
      "b22" /* B22 */
    ) + 1,
    font: "b22" /* B22 */
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontSize.options.a22"
    ),
    value: KITCHEN_TICKET_FONT_SIZE_OPTIONS.indexOf(
      "a22" /* A22 */
    ) + 1,
    font: "a22" /* A22 */
  }
];
var kitchenTicketFontWeightOptionsFactory = (t) => [
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontWeight.options.normal"
    ),
    value: KITCHEN_TICKET_FONT_WEIGHT_OPTIONS.indexOf(
      "normal" /* NORMAL */
    ) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.fontWeight.options.bold"
    ),
    value: KITCHEN_TICKET_FONT_WEIGHT_OPTIONS.indexOf("bold" /* BOLD */) + 1
  }
];
var kitchenTicketLineOptionsFactory = (t) => [
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.line.options.none"
    ),
    value: KITCHEN_TICKET_LINE_OPTIONS.indexOf("none" /* NONE */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.line.options.below"
    ),
    value: KITCHEN_TICKET_LINE_OPTIONS.indexOf("below" /* BELOW */) + 1
  },
  {
    label: t(
      "settingsModule.kitchenTicketSettings.customizingReceiptsTable.line.options.above"
    ),
    value: KITCHEN_TICKET_LINE_OPTIONS.indexOf("above" /* ABOVE */) + 1
  }
];

export { ELEMENT_SPACING_OPTIONS, HEADER_BLANK_SPACE_OPTIONS, KITCHEN_PRINTER_COLOR_OPTIONS, KITCHEN_TICKET_FONT_SIZE_OPTIONS, KITCHEN_TICKET_FONT_WEIGHT_OPTIONS, KITCHEN_TICKET_JUSTIFY_OPTIONS, KITCHEN_TICKET_LINE_OPTIONS, KITCHEN_TICKET_TEXT_POSITION_OPTIONS, elementSpacingOptionsFactory, headerBlankSpaceOptionsFactory, kitchenPrinterColorOptionsFactory, kitchenTicketFontSizeOptionsFactory, kitchenTicketFontWeightOptionsFactory, kitchenTicketJustifyOptionsFactory, kitchenTicketLineOptionsFactory, textPositionOptionsFactory };
